import { Provider } from '@angular/core';
import { MODAL_REGISTRY } from '@features/modals/modal-registry.token';
import { ReedemPromocodeModalComponent } from '@features/affiliates/modals/reedem-promocode-modal/reedem-promocode-modal.component';
import { AffiliatesTiersModalComponent } from '@features/affiliates/modals/affiliates-tiers-modal/affiliates-tiers-modal.component';
import { AffiliatesCodeModalComponent } from '@features/affiliates/modals/affiliates-code-modal/affiliates-code-modal.component';
import { AffiliatesClaimModalComponent } from '@features/affiliates/modals/affiliates-claim-modal/affiliates-claim-modal.component';

export function provideAffiliatesModals(): Provider[] {
  return [
    { provide: MODAL_REGISTRY, useValue: { key: 'ReedemPromocodeModalComponent', component: ReedemPromocodeModalComponent, requiresAuth: true }, multi: true },
    { provide: MODAL_REGISTRY, useValue: { key: 'AffiliatesTiersModalComponent', component: AffiliatesTiersModalComponent }, multi: true },
    { provide: MODAL_REGISTRY, useValue: { key: 'AffiliatesCodeModalComponent', component: AffiliatesCodeModalComponent, requiresAuth: true }, multi: true },
    { provide: MODAL_REGISTRY, useValue: { key: 'AffiliatesClaimModalComponent', component: AffiliatesClaimModalComponent, requiresAuth: true }, multi: true },
  ];
}
